// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./bom-table\"></require>\n  <bom-table mooring-id.bind=\"data.mooringId\" offer-id.bind=\"data.offerId\"></bom-table>\n</template>\n";
// Exports
export default code;